export const notificationCountsSliceName = "notificationCounts"

// Mirrors `apps/notifications_app/models.py`'s `NotificationType`
// (Django `IntegerChoices`) on `ezbuild_back`, pinned by
// `__tests__/notification-counts.contract.test.ts` — a value drifting there
// silently breaks the Projects/Calendar unseen counts.
export const NOTIFICATION_TYPE_ID = {
  PROJECT_CREATED: 11,
  // No dedicated "event created" type exists on the backend; this fires for
  // every invitee (never the organizer) at creation time and on later
  // participant additions, which is the audience Phase 1 needs.
  CALENDAR_EVENT_ASSIGNED: 110
} as const
